import React from 'react';

/* eslint-disable */
const toClass = Component => class extends React.Component {
  render() {
    return <Component {...this.props} />;
  }
};

export default toClass;


// WEBPACK FOOTER //
// ./src/utilities/toClass.js